<prlw-table-modifiers-overlay-ui
  *ngIf="modifier$ | async as modifier"
  [modifier]="modifier"
  [sortDirection]="sortDirection$ | async"
  (closeOverlay)="close()"
  (setModifier)="setModifier($event)"
  (setSort)="setSort($event)"
></prlw-table-modifiers-overlay-ui>
